import qs from 'qs'
import axios from '../config/axios.js'
let config = { headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' } };
let configV1 = { headers: { 'Content-Type': 'application/json;charset=UTF-8' } };
const BASE_URL = '/api/college_manage'
export const courseServer = {
  courseDirectoryList: (params) => {
    return axios.get(`${BASE_URL}/courseDirectory/query`, {params: params}, config).then(res => res.data)
  },
  courseDirectoryAdd: (params) => {
    return axios.post(`${BASE_URL}/courseDirectory/add`, qs.stringify(params), config).then(res => res.data)
  },
  courseDirectoryUpdate: (params) => {
    return axios.post(`${BASE_URL}/courseDirectory/update`, qs.stringify(params), config).then(res => res.data)
  },
  courseDirectoryRemove: (params) => {
    return axios.post(`${BASE_URL}/courseDirectory/remove`, qs.stringify(params), config).then(res => res.data)
  },
  courseBatchUpdate: (params) => {
    return axios.post(`${BASE_URL}/courseDirectory/batchUpdate`, params, configV1).then(res => res.data)
  },
  courseDirectorySet: (params) => {
    return axios.post(`${BASE_URL}/courseDirectory/setTask`, qs.stringify(params), config).then(res => res.data)
  },
  courseDirectoryBatchSet: (params) => {
    return axios.post(`${BASE_URL}/courseDirectory/batch/setTask`, qs.stringify(params), config).then(res => res.data)
  },
  profressionDirectory: (params) => {
    return axios.get(`${BASE_URL}/profession/queryProfressionDirectory`, {params: params}, config).then(res => res.data)
  },
  configDirectory: (params) => {
    return axios.post(`${BASE_URL}/profession/configDirectory`, qs.stringify(params), config).then(res => res.data)
  },
}



// WEBPACK FOOTER //
// ./src/api/server/system.js